import { FilterField, labelId } from 'kontrolEdge/helpers/advancedFilters';
import type { BackboneService } from './backbone.types';

export function makeBackboneFields(
    isViewingAllCustomers = false
): FilterField<BackboneService>[] {
    const fields: FilterField<BackboneService>[] = [
        {
            label: 'Backbone ID',
            key: 'backboneid',
            accessor: (r) => r.subscriptionId ?? r.id,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Name',
            key: 'name',
            accessor: (r) => r.name,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Status',
            key: 'status',
            accessor: (r) => r.status,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'VRFs',
            key: 'vrfs',
            accessor: (r) => (Array.isArray(r.vrfs) ? r.vrfs.join(' ') : r.vrfs ?? ''),
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Tags',
            key: 'tags',
            accessor: (r) => {
                // Match against both the rich tag names (post Tags Manager)
                // and the legacy comma-separated labels so users searching
                // by tag get a hit regardless of which payload shape the
                // backend returned for that row.
                const rich = Array.isArray(r.tagsRich)
                    ? r.tagsRich.map((t) => t.name).filter(Boolean)
                    : [];
                const legacy = Array.isArray(r.tags) ? r.tags : [];
                return [...rich, ...legacy].join(' ');
            },
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Connectors',
            key: 'connectors',
            accessor: (r) => r.connectorsCount ?? 0,
            type: 'number',
            inFreeText: true,
        },
    ];
    if (isViewingAllCustomers) {
        fields.splice(0, 0, {
            label: 'Customer',
            key: 'customer',
            accessor: (r) =>
                [r.customer?.name ?? '', r.customer?.chargebeeCustomerId ?? '']
                    .filter(Boolean)
                    .join(' '),
            type: 'string',
            inFreeText: true,
        });
    }
    for (const f of fields) f.key ??= labelId(f.label);
    return fields;
}
